/*
 *  File: app.modules.ts
 ********************************************************************
 *  Date        Author                 Changes
 ********************************************************************
 *  02/01/18    Dhanalakshmi Lolugu    Created
 ********************************************************************
 * Copyright (c) 2009 Synapse Group, Inc.
 * 225 High Ridge Park, Stamford, Connecticut, 06905-1325, U.S.A.
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of
 * Synapse Group, Inc. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with Synapse Group, Inc.
 */

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { FormsModule, FormControlDirective, FormGroupDirective, ReactiveFormsModule } from '@angular/forms'
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { HeadComponent } from './head/head.component';
import { SearchComponent } from './search/search.component';
import { CancelComponent } from './cancel/cancel.component';
import { SearchService } from './services/search.service';
import { TokenService } from './services/token.service';
import { ConfirmComponent } from './confirm/confirm.component';
import { FooterComponent } from './footer/footer.component';
import { CsaService } from './services/csa.service';
import { ErrorComponent } from './error/error.component';
import { CustomerServiceComponent } from './customer-service/customer-service.component';

@NgModule({
  declarations: [
    AppComponent,
    HeadComponent,
    FooterComponent,
    SearchComponent,
    CancelComponent,
    ConfirmComponent,
    ErrorComponent,
    CustomerServiceComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  providers: [
    AppComponent,
    TokenService,
    SearchService,
    CsaService,
    FormControlDirective,
    FormGroupDirective
  ],
  bootstrap: [AppComponent]
})
/**
 *
 * @author dlolugu1271
 * @description This an app module class which describes how the
 * selfservice application parts fit together.
 * 
 */
export class AppModule { }



// WEBPACK FOOTER //
// /home1/jenkins/jobs/SUPPORTCS_AJS_PROD/workspace/src/app/app.module.ts